import { render } from "./ProfileFeed.vue?vue&type=template&id=55b75c1f"
import script from "./ProfileFeed.vue?vue&type=script&lang=js"
export * from "./ProfileFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__